// @flow


import clsx from 'clsx';
import { openDialog } from '../../../react/features/base/dialog/actions';
import { isMobileBrowser } from '../../../react/features/base/environment/utils';
import { translate } from '../../../react/features/base/i18n/functions';
import AbstractButton, { IProps as AbstractButtonProps } from '../../../react/features/base/toolbox/components/AbstractButton';
import React from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import Env from '../../modules/Environment';
import {
    NAVIGATION_FEATURE_TUTORIAL,
    VERSION_FEATURE
} from '../../modules/Tutorial/constants';

import { IconTutorial } from '../base/icons/svg';

import ShowTutorialDialog from './ShowTutorialDialog';

type IProps = AbstractButtonProps & {

    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Dispatch<any>,

    /**
     * Whether or not the button is disabled.
     */
    _isDisabled: boolean
};

/**
 * Implements an {@link AbstractButton} to open the user documentation in a new window.
 */
class ShowButtonTutorial extends AbstractButton<IProps, *> {
    accessibilityLabel = 'tutorial.btnTooltip';
    icon = IconTutorial;
    label = 'tutorial.dialogTitle';

    /**
     * Dynamically retrieves tooltip based on sharing state.
     */
    get tooltip() {
        return 'tutorial.dialogTitle';
    }


    /**
     * Handles clicking / pressing the button, and opens a new dialog.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;

        dispatch(openDialog(ShowTutorialDialog));
    }

    /**
     * Overrides AbstractButton's {@link Component#render()}.
     *
     * @override
     * @protected
     * @returns {boReact$Nodeolean}
     */
    render(): React$Node {
        const { _showCounter, _isVisibleForHW, _isHWDevice, isMobile } = this.props;
        const toggleCustomClass = _showCounter && !_isHWDevice ? 'color-yellow' : '';

        return (
            <>
                {!isMobile && (_isVisibleForHW || !_isHWDevice)
                    && <div
                        className = { clsx(toggleCustomClass, 'toolbar-button-tutorial') }
                        key = 'tutorial-btn'>
                        {super.render()}
                        { _showCounter && _isHWDevice && <span className={'tutorial-dot'}></span>}
                    </div>}
            </>

        );
    }
}

/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state): Object {
    const { versionFeature, [NAVIGATION_FEATURE_TUTORIAL]: featureTutorialStore } = state['wildix/features/tutorial'];
    const isVersionDifferent = versionFeature !== VERSION_FEATURE;

    return {
        _showCounter: isVersionDifferent,
        isMobile: isMobileBrowser(),
        _isVisibleForHW: (!featureTutorialStore.isAllStepsWereShow || isVersionDifferent) && Env.isWizyconf(),
        _isHWDevice: Env.isWizyconf()
    };
}


export default translate(connect(_mapStateToProps)(ShowButtonTutorial));
